import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Truck, RotateCw } from "lucide-react";
import { http, errMsg } from "../../lib/api";

const when = (iso) => (iso ? new Date(iso).toLocaleString("en-AU", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" }) : "");

const Row = ({ o, i, onDone }) => {
  const [busy, setBusy] = useState(false);
  const resend = async () => {
    setBusy(true);
    try {
      const r = await http.post(`/orders/${o.id}/resend`);
      if (r.data.email_status === "sent") toast.success(`Sent to ${o.customer_email}`);
      else toast.error(`Still failing: ${r.data.email_error || "unknown error"}`);
      onDone();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <li data-testid={`delivery-row-${i}`} className="flex flex-wrap items-center gap-2 border-t border-stone-100 py-1.5 text-sm">
      <span className={`rounded-sm px-1.5 text-xs font-bold ${o.email_status === "failed" ? "bg-red-100 text-red-800" : "bg-amber-100 text-amber-800"}`}>
        {o.email_status === "failed" ? "Failed" : "Waiting"}
      </span>
      <b className="text-[#2B2A26]">{o.customer_email}</b>
      <span className="min-w-0 flex-1 truncate text-stone-500">{o.product_slug} · {when(o.created_at)}
        {o.email_error && <span className="text-red-700"> · {o.email_error.slice(0, 90)}</span>}
        {o.retry_at && <span> · auto-retry {when(o.retry_at)}</span>}
      </span>
      <button data-testid={`delivery-resend-${i}`} disabled={busy} onClick={resend}
        className="inline-flex items-center gap-1 rounded-sm bg-[#2B2A26] px-2.5 py-1 text-xs font-bold text-white hover:bg-black disabled:opacity-40">
        <RotateCw size={11} className={busy ? "animate-spin" : ""} /> {busy ? "Sending…" : "Resend"}
      </button>
    </li>
  );
};

export const DeliveryStatus = () => {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => http.get("/orders").then((x) => setRows(x.data.filter((o) => !o.test && o.email_status !== "sent"))).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  if (!rows?.length) return null;
  return (
    <section data-testid="delivery-status-panel" className="mb-6 rounded-lg border border-red-200 bg-white p-4">
      <div className="flex items-center gap-2">
        <Truck size={16} className="text-red-600" />
        <b className="text-[#2B2A26]">Buyer deliveries need attention</b>
        <span data-testid="delivery-status-count" className="text-sm text-stone-500">{rows.length} not delivered yet</span>
      </div>
      <ul className="mt-2 max-h-72 overflow-y-auto">{rows.map((o, i) => <Row key={o.id} o={o} i={i} onDone={load} />)}</ul>
    </section>
  );
};
